module.exports = __webpack_public_path__ + "images/emoji/cold_sweat.8b3986845df6094e340c.png";